import { IGeoTeknikkRapport } from "../reportSchemas/geoteknikSchema";

export const GEOTEKNIKRAPPORT_INIT_DATA: IGeoTeknikkRapport = {
  generellInfo: {
    deloppgavenummer: "",
    oppdragsNavn: "",
    oppdragsNummer: "",
    oppdragsGiver: {
      navn: "",
      kontaktPerson: "",
    },
    oppdragsLeder: "",
  },
  innstillinger: {
    veiledningsTekst: true,
    eksempelTekst: true,
  },
  prosjektInformasjon: {
    hoydeSystem: "NN2000",
    koordinatSystem: "",
    koordinater: {
      sone: "",
      nord: "",
      ost: "",
    },
    sirkelDiameter: 300,
    zoomLevel: 0,
    eiendomsInformasjon: {
      gnr: null,
      bnr: null,
      snr: null,
      by: "",
    },
    tilgjengelighet: "Åpen",
    saksbehandler: "",
    ansvarligEnhet: "",
  },
  laboratorieresultater: "",
};

export const GEOTEKNIKRAPPORT_OMRAADESTABILITET_INIT_DATA: IGeoTeknikkRapport = {
  generellInfo: {
    deloppgavenummer: "",
    oppdragsNavn: "",
    oppdragsNummer: "",
    oppdragsGiver: {
      navn: "",
      kontaktPerson: "",
    },
    oppdragsLeder: "",
  },
  innstillinger: {
    veiledningsTekst: true,
    eksempelTekst: true,
  },
  prosjektInformasjon: {
    hoydeSystem: "NN2000",
    koordinatSystem: "",
    koordinater: {
      sone: "",
      nord: "",
      ost: "",
    },
    sirkelDiameter: 300,
    zoomLevel: 0,
    eiendomsInformasjon: {
      gnr: null,
      bnr: null,
      snr: null,
      by: "",
    },
    tilgjengelighet: "Åpen",
    saksbehandler: "",
    ansvarligEnhet: "",
  },
};
